<template>
  <LoginForm v-if="!jwt && clientName" />
</template>

<script lang="ts">
import LoginForm from "@/components/LoginForm.vue";
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import {
  showToastrError,
  showToastrSuccess
} from "@/composables/notifications";
import { useRouter } from "vue-router";

export default {
  components: { LoginForm },
  setup() {
    const store = useStore();

    const jwt = computed(() => store.state.auth.jwt),
      clientName = computed(() => store.state.config.config?.clientName);

    const router = useRouter();

    onMounted(() => {
      store.commit("auth/UNSET_JWT");
      watch(
        () => !!jwt.value,
        (newVal, oldVal) => {
          console.log(newVal, oldVal);

          if (newVal && !oldVal) {
            console.log("logged in");

            store.dispatch("syncFirmwareVersion", {
              client: clientName.value,
              callback: async () => {
                showToastrSuccess("Firmware version synchronized");
                store.commit("auth/UNSET_JWT");
                await router.replace({ name: "app" });
              },
              errorCallback: () => {
                store.commit("auth/UNSET_JWT");
                showToastrError("Firmware version synchronization failed");
              }
            });
          }
        }
      );
    });

    return {
      jwt,
      clientName
    };
  }
};
</script>
